<script>
  import { getContext } from 'svelte'
  import { cssPrefix } from '../helper-classes.js'

  export let elementName = null
  export let variant = null
  export let config = null

  export let id = null
  // export let label
  // export let info

  const FormTheme = getContext('FormTheme')

  {
    const layout = config.layout || getContext('formGroupLayout')
    if (layout === 'TwoCols') {
      config.blockClasses = [`${cssPrefix}form-block`, 'is-horizontal']
    } else {
      config.blockClasses = [`${cssPrefix}form-block`]
    }
  }
</script>

<svelte:component this={FormTheme[elementName]} let:inputClass {elementName} {variant} {config} {id}>
  <slot name="a" slot="a" let:inputClass {inputClass} />
  <slot name="b" slot="b" let:inputClass {inputClass} />
  <slot name="from" slot="from" let:inputClass {inputClass} />
  <slot name="to" slot="to" let:inputClass {inputClass} />
  <slot {inputClass} />
</svelte:component>
